import type { Period } from '@weft/types';
import type { Dayjs } from '@weft/utils';
import { dayjs } from '@weft/utils';

export function getCurrentInvoiceBillingCycle(contractStartDate: Dayjs, billingIntervalInMoths: number): Period {
  const contractStartOfMonth = contractStartDate.startOf('month');
  const monthsFromStartOfContract = dayjs()
    .startOf('month')
    .diff(contractStartOfMonth, 'month');

  const amountOfPastBillingCycles = Math.floor(monthsFromStartOfContract / billingIntervalInMoths);

  const lastDayInBillingCycle = contractStartOfMonth
    .add(monthsFromStartOfContract, 'month')
    .add(billingIntervalInMoths - 1, 'month')
    .endOf('month');

  const startTime = contractStartOfMonth
    .add(amountOfPastBillingCycles, 'month')
    .startOf('month');

  return {
    startTime: startTime.toDate(),
    endTime: lastDayInBillingCycle.toDate(),
  };
}